import { Box, Button, Typography } from '@mui/material';
import {useTheme} from "@mui/material/styles";

function DeckFinishedView({onContinue}: {onContinue: () => void}) {

    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: 'background.default',
                padding: 3,
                textAlign: 'center',
            }}
        >
            <Typography variant="h4" sx={{color: theme.palette["darkGreen"].main}} gutterBottom>
                Well done, you completed all lessons!
            </Typography>
            <Button
                variant="contained"
                onClick={onContinue}
                size={"large"}
                sx={{
                    mt: 2,
                    borderRadius: 3,
                    color: "white",
                    backgroundColor: theme.palette["darkGreen"].main,
                    "&:hover": {
                        backgroundColor: theme.palette["darkGreen"].dark,
                    },
                }}
            >
                Continue
            </Button>
        </Box>
    );
}

export default DeckFinishedView;